/**
 * Stytch SMS OTP Creation Hook
 *
 * This hook provides functionality for creating TOTP (Time-based One-Time Password)
 * authentication using the Stytch B2B headless client.
 */
import { useCallback } from 'react';
import { getStytchClient } from '../../../../adapters/react/client/headless-client';
export function useStytchUpdateMember() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.organization.members.update({
                member_id: data.memberId,
                email_address: data.emailAddress,
                name: data.name,
                untrusted_metadata: data.untrustedMetadata,
                is_breakglass: data.isBreakglass,
                mfa_phone_number: data.mfaPhoneNumber,
                mfa_enrolled: data.mfaEnrolled,
                default_mfa_method: data.defaultMfaMethod,
                roles: data.roles,
                unlink_email: data.unlinkEmail,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                memberId: result.member_id,
                member: result.member,
                organization: result.organization,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to update member',
                data: error,
            };
        }
    }, []);
}
